import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../../Escritorio/Instrucciones';
import useConfigAuth from '../../../../../../Hooks/useConfigAuth';
import BotoneraBottom from '../../../../Compartidos/BotoneraBottom';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../../actions/almacenarEjercicioActions';

import { Flex, FlexFull, DivFlex, ImgB10, InputM50, ButtonM49, AvanzarImg, AvanzarBtn, TextM50 } from '../../../../../Css/StyledMatematica';

const instrucciones = 'Selecciona las manos y resuelve la suma.';
const miniInstrucciones = 'Selecciona las manos y resuelve la suma.';

const M50 = () => {
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [numero, setNumero] = useState('');
    const [manos, setManos] = useState([]);
    const [coloresManos, setColoresManos] = useState([]);
    const [manoUno, setManoUno] = useState(0);
    const [manoDos, setManoDos] = useState(0);
    const [indexes, setIndexes] = useState();
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [contarErrores, setContarErrores] = useState(0);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [tipoEjercicio, setTipoEjercicio] = useState('');

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const lista_usada = useSelector(state => state.informacion.lista_usada);
    const sesion = useSelector((state) => state.ejercicio.sesion);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const setearManos = (e, mno) => {
        e.preventDefault();
        if(manos.length === 2) {
            return;
        }
        const newList = JSON.parse(JSON.stringify(manos));
        newList.push(mno);
        setManos(newList);
    }

    const borrar = (e) => {
        e.preventDefault();
        if(manos.length === 0) {
            return;
        }
        setManos([]);
    }

    const onSubmit = (e) => {
        e.preventDefault();
    }

    const verificar = (e) => {
        e.preventDefault();
        if((manoUno + manoDos).toString() !== (comparar[count-1].cantidad_1 + comparar[count-1].cantidad_2).toString() || numero.toString() !== (comparar[count-1].cantidad_1 + comparar[count-1].cantidad_2).toString()) {
            console.log('mal');
            setDisable(true);
            setContarErrores(contarErrores + 1);
            setIsIncorrect(true);
            setTimeout(() => {
                setIsIncorrect(false);
            }, 300);
            TryAgain();
            setTimeout(() => {
                setDisable(false);
                if((manoUno + manoDos).toString() !== (comparar[count-1].cantidad_1 + comparar[count-1].cantidad_2).toString()) {
                    setManoUno(0);
                    setManoDos(0);
                    setManos([]);
                }
                if(numero.toString() !== (comparar[count-1].cantidad_1 + comparar[count-1].cantidad_2).toString()) {
                    setNumero('');
                }
            }, 300);
        } else {
            console.log("bien");
            setDisable(true);
            setIsCorrect(true);
            setTimeout(() => {
                setIsCorrect(false);
            }, 300);
            GoodWork();
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setNumero('');
                    setManoUno(0);
                    setManoDos(0);
                    setManos([]);
                    setCount(count + 1);
                    
                }, 300);
            } else {
                setTimeout(() => {
                    setUltimoTiempo(true);
                    dispatch( finalizarEjercicioAction() );
                    setNumero(0);
                    setManoUno(0);
                    setManoDos(0);
                    setManos([]);
                }, 1500);
            }
        }
    }

    useEffect(() => {
        const min = 1;
        const max = 5;
        const listaUno = [];
        const listaDos = [];
        const randomLista = (min,max,lista) => {
            for(let i = 0; i < 5; i++){
                let randomNumero = Math.floor(Math.random() * (max - min +1)) + min;
                lista.push(randomNumero);
            }
            return lista
        }
        const randomListaUno = randomLista(min,max,listaUno);
        const randomListaDos = randomLista(min,max,listaDos);

        const array = ['dedos_1', 'dedos_2', 'dedos_3', 'dedos_4', 'dedos_5'];

        const modelo = [
            {id:'1', cantidad_1:randomListaUno[0], cantidad_2:randomListaDos[0]},
            {id:'2', cantidad_1:randomListaUno[1], cantidad_2:randomListaDos[1]},
            {id:'3', cantidad_1:randomListaUno[2], cantidad_2:randomListaDos[2]},
            {id:'4', cantidad_1:randomListaUno[3], cantidad_2:randomListaDos[3]},
            {id:'5', cantidad_1:randomListaUno[4], cantidad_2:randomListaDos[4]}
        ]

        setComparar(modelo);
        setColoresManos(array);
        setIndexes(modelo.length);
        setTipoEjercicio('unidad');
    }, [])

    useEffect(() => {
        const newList = JSON.parse(JSON.stringify(manos));
        switch (newList[0]) {
            case 'dedos_1':
                setManoUno(1)
                break;
            case 'dedos_2':
                setManoUno(2)
                break;
            case 'dedos_3':
                setManoUno(3)
                break;
            case 'dedos_4':
                setManoUno(4)
                break;
            case 'dedos_5':
                setManoUno(5)
                break;
            default:
                break;
        }
        switch (newList[1]) {
            case 'dedos_1':
                setManoDos(1)
                break;
            case 'dedos_2':
                setManoDos(2)
                break;
            case 'dedos_3':
                setManoDos(3)
                break;
            case 'dedos_4':
                setManoDos(4)
                break;
            case 'dedos_5':
                setManoDos(5)
                break;
            default:
                break;
        }

    }, [manos])

    useEffect(() => {
        dispatch(setearEjercicioAction('M50') );
        dispatch(setearUrlAnteriorAction('matematica/calculo/suma/ejercitacion/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'ejercicio': "M50",
                    'errores': contarErrores,
                    'tiempo': tiempoFinal,
                    'id_paciente': id_paciente,
                    'lista_usada': lista_usada,
                    'tipo': tipoEjercicio,
                    sesion
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} />
            {iniciar
                ?
                <Flex direction="column" height="100%" width="100%" align="center">
                    <Flex margin="auto" width="100%" align='center' justify="space-evenly"
                    isCorrect={isCorrect}
                    isIncorrect={isIncorrect}
                    >
                        <FlexFull direction='column' justify='center' align='start'>
                            {/* MANOS ARRIBA */}
                            <Flex margin='0px 0px 5vh 0px'>
                                <DivFlex flex='flex' wrap='wrap' justify='center' align='center' minw='50vw' maxw='46vw' minwd='40vw' maxwd='40vw' minwlg='36vw' maxwlg='36vw' minh='24vw' maxh='24vw' minhd='19vw' maxhd='19vw' minhlg='17vw' maxhlg='17vw' bradius='20px'>
                                    {manos.map((item, i) =>
                                    <div key={i}>
                                        <ImgB10 key={i} src={`/img/${item}.png`} w='18vw' wlg='16vw' />
                                    </div>    
                                    )}
                                </DivFlex>
                                <ButtonM49
                                        disabled={disable}
                                        onClick={(e) => borrar(e)}
                                    >
                                        <ImgB10 src={`/img/icono_basurero.png`} w='4vw' wm='3.5vw' wt='3vw' wd='3vw' wlg='2.5vw' m='0.3vw' /> 
                                </ButtonM49>
                            </Flex>
                            {/* FIN MANOS ARRIBA */}
                            {/* SUMA */}
                            <Flex>
                                <TextM50>{comparar[count-1].cantidad_1}</TextM50><TextM50>+</TextM50><TextM50>{comparar[count-1].cantidad_2}</TextM50><TextM50>=</TextM50>
                                <form onSubmit={(e) => onSubmit(e)}>
                                    <InputM50 type="numeric" min="1" max="10" value={numero} onChange={(e) => setNumero(e.target.value)} disabled={disable} />
                                </form>
                            </Flex>
                            {/* FIN SUMA */}
                        </FlexFull>
                        {/* SIDEBAR */}
                        <DivFlex flex='flex' direction='column' align='center' justify='center' padding='1.5vh' pt='1.1vw' pd='0vw'  bradius='20px' bs='0px 4px 4px rgba(0, 0, 0, 0.25)' wlg='3.3vw'>
                            {coloresManos.map((item, i) => 
                                <ButtonM49 
                                    key={i} 
                                    onClick={(e) => setearManos(e, item)}
                                >
                                    <ImgB10 src={`/img/${item}.png`} w='7vw' wt='5.5vw' wd='4vw' wlg='3.5vw' m='0vh 0vw 0vh -1.2vw' mt='0vh 0vw -2vh -0.5vw' md='0vh 0vw -1vh 0vw' mlg='-3vh 0vw -1vh 0vw' />
                                </ButtonM49> 
                            )}
                        </DivFlex>
                    </Flex>



                    {/* INSTRUCCIONES */}
                    <Flex margin="0 0rem 0 0rem" width="90%" justify="space-between">
                        <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        <AvanzarBtn
                            disabled={disable}
                            onClick={(e) => verificar(e)}
                        >
                            <AvanzarImg src={'/img/play.png'} /> 
                        </AvanzarBtn>
                    </Flex>
                </Flex>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default M50;